import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'

import { AccountLimitReached, AuthLayout } from '../../components'
import { withCampaignFallback } from '../../utils/campaign-attribution'
import { type AuthPageEventData, getEventDataFromQuery } from '../../utils/event-data'

export interface SignupAttemptsErrorPageProps {
  eventData: AuthPageEventData
}

export function SignupAttemptsErrorPage({ eventData }: SignupAttemptsErrorPageProps) {
  return (
    <AuthLayout>
      <AccountLimitReached eventData={eventData} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const eventData = withCampaignFallback(getEventDataFromQuery(ctx.query), ctx.query, ctx)
  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      eventData,
    },
  }
}

export const SignupAttemptsErrorPageExports = {
  getServerSideProps,
}
